// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"a5e2ec09","301":"6f399425","354":"6f399425","524":"6f399425","676":"6f399425"}[chunkId] + ".chunk.css";
};